import { Link } from '@/components/atoms/Link';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import React from 'react';

type LinkType = {
  text: string;
  href: string;
  icon?: React.ReactElement;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export interface BreadcrumbProps {
  links: LinkType[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ links }) => {
  return (
    <nav className="flex items-center">
      {links.map((link, i) => {
        const isLastLink = i === links.length - 1;
        return (
          <React.Fragment key={i}>
            <div
              className={`flex items-center gap-s rounded-xsmall px-s py-xs ${isLastLink ? '' : 'hover:bg-blue-light'}`}
            >
              {link.icon}
              <Link
                className={`text-microLight ${isLastLink ? 'cursor-default text-neutral-800' : 'text-blue-medium'}`}
                href={link.href}
                onClick={isLastLink ? undefined : link.onClick}
              >
                {link.text}
              </Link>
            </div>

            {i !== links.length - 1 && (
              <ChevronRightIcon className="mx-xs h-l w-l text-neutral-800" />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
